<template>
	<div class="content">
		<div class="content_head">

			<select v-model="areaID" v-if="$store.state.user.UserType==0" @change="selectArea">
				<option v-for="(i,index) in $store.state.area" :value="i.areaID">{{i.areaName}}</option>
			</select>

			<select v-model="ShopID" title="选择店铺" @change="pageIndex=1;getData()" v-if="$store.state.user.UserType==0">
				<option v-for="i in Shop" :value="i.ShopID">
					{{i.ShopName}}
				</option>
			</select>
			<input type="text" placeholder="扫描客户二维码|输入手机号|客户姓名" class="search" @keypress.enter="pageIndex=1;getData()"
				v-model="search" />
			&nbsp;&nbsp;
			<input type="text" v-model="beginData" class="search" placeholder="开始时间(格式:2021-01-01)" />
			~
			<input type="text" v-model="endTime" class="search" placeholder="结束时间(格式:2021-01-01)" />
			<button type="button" class="button " @click="pageIndex=1;getData()">查找</button>
		</div>
		<div class="content_body">
			<table>
				<thead>
					<tr>
						<th>序号</th>
						<th>客户姓名</th>
						<th>手机号</th>
						<th>借书数量</th>
						<th>总价值</th>
						<th>付费记录</th>
					</tr>
				</thead>
				<tbody>

					<tr v-for="(i,index) in customers">
						<td  >
							{{index+1+ (pageIndex-1)*pageRows}}
						</td>
						<td>{{i.CustomerName}}</td>
						<td>{{i.CustomerPhone}}</td>
						<td>{{i.count+'本'}}</td>
						<td>{{i.money+'元'}}</td>
						<td>
							<button type="button" class="button"
								@click="$router.replace('/customerQuery/customerPayRecord/'+i.CustomerID)">付费记录</button>
						</td>
					</tr>

				</tbody>
			</table>
		</div>
		<div class="foot_pages">共计:
			<span class="red">{{count+'人'}}</span>
			<button class="button" :class="{'disabled':up}" :disabled="up" @click="changePages('up')">上一页</button>
			<span>{{page}}</span>

			<select v-model="pageRows" @change="changePageRows">
				<option value="5">5/页</option>
				<option value="10">10/页</option>
				<option value="15">15/页</option>

			</select>
			<button class="button" :class="{'disabled':down}" :disabled="down" @click="changePages('down')">下一页</button>
		</div>

	</div>

</template>

<script>
	import j from './customerQuery.js'
	export default j
</script>

<style>

</style>
